// Copyright (c) 2016 Deere & Company

import Accordion, {getDefaultState as getAccordionDefaultState} from '../../../shared/components/smart-accordion/state/accordion';
import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import CreateClaimModal, {getDefaultState as getCreateClaimModalState} from '../../../shared/state/create-claim-modal';
import Dealers, {getDefaultState as getDealersDefaultState} from '../../shared/state/dealers';
import Facets, {getDefaultState as getFacetsDefaultState} from './facets';
import HighOnRentalDays, {getDefaultState as getHighOnRentalDaysDefaultState} from '../../shared/state/high-rental';
import Modal, {getDefaultState as getModalDefaultState} from '../../shared/state/modal';
import ProductSearchResult, {getDefaultState as getProductSearchResultDefaultState} from '@deere/cps-it.warranty-model-factory/lib/product-search-results';
import SearchByDropDown, {getDefaultState as getSearchByDropDownDefaultState} from '../../shared/state/search-by-dropdown';
import SearchFilters, {getDefaultState as getSearchFiltersDefaultState} from './search-filters';
import SearchResults, {getDefaultState as getSearchResultsDefaultState} from './search-results';
import t from 'tcomb';

const State = t.struct({
    busyCounter: BusyCounter,
    createClaimModal: CreateClaimModal,
    dealers: Dealers,
    facets: Facets,
    filteredSearchResults: SearchResults,
    highRentalDays: HighOnRentalDays,
    product: ProductSearchResult,
    reportsAccordion: Accordion,
    searchByDropDown: SearchByDropDown,
    searchFilters: SearchFilters,
    searchQueryString: t.String,
    searchResults: SearchResults,
    statusChangeModal: Modal
}, 'State');

export const getDefaultState = () =>
    new State({
        busyCounter: getBusyCounterDefaultState(),
        createClaimModal: getCreateClaimModalState(),
        dealers: getDealersDefaultState(),
        facets: getFacetsDefaultState(),
        filteredSearchResults: getSearchResultsDefaultState(),
        highRentalDays: getHighOnRentalDaysDefaultState(),
        product: getProductSearchResultDefaultState(),
        reportsAccordion: getAccordionDefaultState('product-search-reports'),
        searchByDropDown: getSearchByDropDownDefaultState(),
        searchFilters: getSearchFiltersDefaultState(),
        searchQueryString: '',
        searchResults: getSearchResultsDefaultState(),
        statusChangeModal: getModalDefaultState()
    });

export default State;



// WEBPACK FOOTER //
// ./src/product/search/state/index.js